/**
 * Created by sxp23 on 2/1/2018.
 */
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';


import { CommonService} from './../common.service'
import { EsriMapComponent} from './esrimap.component'

@NgModule({
  declarations: [EsriMapComponent],
  imports: [BrowserModule,CommonModule,FormsModule],
  providers: [CommonService],
  exports: [EsriMapComponent],
  bootstrap: [EsriMapComponent]
})

export class EsriMapModule { }
